import {
  backgroundColorCss,
  colorCss,
  mobileBackgroundColorCss,
  mobileColorCss,
} from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

export interface TwoStepPaymentFormStepButtonUiProps {
  backgroundColor?: string
  mobileBackgroundColor?: string
  color: string
  mobileColor?: string
}

const TwoStepPaymentFormStepButtonUi = styled.button<TwoStepPaymentFormStepButtonUiProps>`
  display: flex;
  padding: 15px 0;
  width: 100%;
  border: none;
  outline: none;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }

  ${colorCss}
  ${backgroundColorCss}

  ${p => p.theme.phone} {
    ${mobileColorCss}
    ${mobileBackgroundColorCss}
  }
`

export default TwoStepPaymentFormStepButtonUi
